module.exports = __webpack_public_path__ + "static/cabina-conductor---grada-de-ingreso-974d3d9afdccae41051427b72ac6c819.jpg";